/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Pill_OneInputs */

const en_ui_laps_pill_one = /** @type {(inputs: Ui_Laps_Pill_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 device lap`)
};

const de_ui_laps_pill_one = /** @type {(inputs: Ui_Laps_Pill_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Geräterunde`)
};

/**
* | output |
* | --- |
* | "1 device lap" |
*
* @param {Ui_Laps_Pill_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_pill_one = /** @type {((inputs?: Ui_Laps_Pill_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Pill_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_pill_one(inputs)
	return de_ui_laps_pill_one(inputs)
});